import qahoy from "views_shared/app/javascript/scripts/qahoy";
import qapi from "views_shared/app/javascript/api";

// Both calls resolve to true only when the write landed AND the page has been refetched, so the
// caller can keep its pending UI up and close its form/confirmation on success alone. Failures —
// both shapes: a resolved `{ error }` (the mutation helpers don't throw on a non-2xx) and a thrown
// network error — go to generalError, the recoverable save-error channel, never to asyncError,
// which is re-thrown to the page error boundary and would tear the whole page down.
const useRepresentationApi = ({ setIsUpdating, setGeneralError, silentReload }) => {
  const addRepresentation = async ({ promoEntityId, promoterProfileId }) => {
    try {
      setIsUpdating(true);
      setGeneralError(null);

      qahoy.track("Products#addRepresentation");

      const response = await qapi.representations.create({ promoEntityId, promoterProfileId });

      if (!response.data) {
        setGeneralError(response);
        return false;
      }

      await silentReload();
      return true;
    } catch (error) {
      setGeneralError(error);
      return false;
    } finally {
      setIsUpdating(false);
    }
  };

  const deleteRepresentation = async (representationId) => {
    try {
      setIsUpdating(true);
      setGeneralError(null);

      qahoy.track("Products#deleteRepresentation");

      const response = await qapi.representations.destroy(representationId);

      if (!response.data) {
        setGeneralError(response);
        return false;
      }

      await silentReload();
      return true;
    } catch (error) {
      setGeneralError(error);
      return false;
    } finally {
      setIsUpdating(false);
    }
  };

  return { addRepresentation, deleteRepresentation };
};

export default useRepresentationApi;
